module.exports = __webpack_public_path__ + "img/8.7df6943c.jpg";